import React, { PureComponent } from "react";
import { connect } from "react-redux";
import build from "redux-object";
import { Link } from "react-router-dom";
import { Grid, Input, Button, Dropdown, Radio, Menu, Icon, Label } from "semantic-ui-react";
import { get, isEmpty } from "lodash";
import { ErrorMessage, Form, Formik } from "formik";
import { object, string, number, mixed, array, boolean } from "yup";
import { clone as cl } from "lodash";

import Layout from "../Common/Layout";
import Loader from "../Common/Loader";
import AppButton from "../Common/AppButton";
import map from "lodash/map";
import { fetchTenantCurrencies } from "../../actions/tenants.actions";

class DiscountForm extends PureComponent {
  save = discount => {
    this.props.saveDiscountChanges(discount);
  };

  componentDidMount() {
    const { tenantCurrencies, dispatch } = this.props;
    if (!tenantCurrencies) {
      dispatch(fetchTenantCurrencies());
    }
  }
  pricesList = value => {
    isEmpty(value.filter(item => item.currency == this.props.currentTenantCurrency));
  };

  handlePrices = data => {
    const discountPrices = data.map(price => {
      price.removed = true;
      return price;
    });
    return discountPrices;
  };

  handleProductChange = (e, data, setFieldValue) => {
    const { action } = this.props;
    setFieldValue("discountableProductSlug", data.value);

    if (action === "create") {
      const discountName = data.options
        .find(option => option.value === data.value)
        .text.replace(/ *\([^)]*\) */g, " ")
        .trim();
      const item = `${this.props.customerInvoicesPrefix}-S-${discountName}-Disc`;
      setFieldValue("item", item);
    }
  };
  render() {
    const {
      appliesOnProduct,
      appliesOnProductGroup,
      appliesForCustomerGroup,
      productOptions,
      productGroupOptions,
      customerGroupOptions,
      page,
      discount,
      tenantSlug,
      tenantCurrencies
    } = this.props;

    return (
      <Layout.Page>
        <Layout.Header
          link={<AppButton icon="angle left" content="Back" as={Link} to="/discounts" size="large" />}
          title={`${page} discount`}
        />
        {!isEmpty(discount) || page === "Create" ? (
          <Layout.Content>
            <Grid relaxed padded stackable>
              <Grid.Row>
                <Grid.Column>
                  <Formik
                    enableReinitialize
                    initialValues={{
                      slug: get(discount, "slug", ""),
                      name: get(discount, "name", ""),
                      item: get(discount, "item", ""),
                      netsuiteDescription: get(discount, "netsuiteDescription", ""),
                      prices: get(this.props, "discount.discountFixedAmounts", []),
                      discountType: get(discount, "discountType", "percentage"),
                      discountableProductType: get(discount, "discountableProductType", ""),
                      discountableCustomerType: get(discount, "discountableCustomerType", ""),
                      discountableProductSlug: get(discount, "discountableProduct.id", ""),
                      discountableCustomerSlug: get(discount, "discountableCustomer.id", ""),
                      addingCurrency: false,
                      editingCurrency: false,
                      amount: get(discount, "amount", "0"),
                      currency: "",
                      amountIndex: null,
                      currencyIndex: null
                    }}
                    validationSchema={object().shape({
                      name: string().required("Name is required!"),
                      item: string().required("Item/Netsuite product ID is required!"),
                      amount: number().when(
                        "discountType",
                        {
                          is: "percentage",
                          then: number("Price has to be a positive number!")
                            .typeError("Price must be positive number!")
                            .positive("Price must be positive!")
                        },
                        {
                          is: "fixed",
                          then: number("Price has to be a positive number!")
                            .typeError("Price must be positive number!")
                            .positive("Price must be positive!")
                        }
                      ),
                      currency: string().when("addingCurrency", {
                        is: true,
                        then: string().required("Currency is required!")
                      }),
                      prices: array().when("discountType", {
                        is: "fixed",
                        then: array()
                          .min(1, "Please insert at least 1 prices!")
                          .required("Required")
                      }),
                      addingCurrency: boolean(),
                      editingCurrency: boolean(),
                      discountType: string().required("Discount type is required!"),
                      discountableProductSlug: mixed().test(
                        "discountableProductSlug-validation",
                        "Product or product group is required!",
                        function(value) {
                          const { discountableProductSlug } = this.parent;
                          return !isEmpty(discountableProductSlug);
                        }
                      ),
                      discountableCustomerSlug: mixed().test(
                        "discountableCustomerSlug-validation",
                        "Customer group is required!",
                        function(value) {
                          const { discountableCustomerSlug } = this.parent;
                          return !isEmpty(discountableCustomerSlug);
                        }
                      )
                    })}
                    onSubmit={(values, { setSubmitting }) => {
                      this.save(values);
                      setSubmitting(false);
                    }}
                  >
                    {({ handleChange, handleBlur, errors, isSubmitting, isValid, setFieldValue, touched, values }) => (
                      <Form widths="equal" data-test="discount_form">
                        <Grid padded>
                          {!isEmpty(values.slug) && (
                            <Grid.Row>
                              <Grid.Column verticalAlign="middle" width={4}>
                                <h4>Slug</h4>
                              </Grid.Column>
                              <Grid.Column width={4} stretched textAlign="center">
                                <Input
                                  fluid
                                  name="slug"
                                  required
                                  placeholder="Slug"
                                  value={values.slug}
                                  disabled={true}
                                  data-test="slug"
                                />
                              </Grid.Column>
                            </Grid.Row>
                          )}
                          <Grid.Row>
                            <Grid.Column verticalAlign="middle" width={4}>
                              <h4>Name</h4>
                            </Grid.Column>
                            <Grid.Column width={4} stretched textAlign="center">
                              <Input
                                fluid
                                name="name"
                                required
                                error={touched && !isEmpty(errors.name)}
                                placeholder="Name"
                                value={values.name}
                                onChange={(e, data) => setFieldValue("name", data.value)}
                                data-test="name"
                              />
                            </Grid.Column>
                          </Grid.Row>
                          <Grid.Row>
                            <Grid.Column verticalAlign="middle" width={4}>
                              <h4>Item/Netsuite product ID</h4>
                            </Grid.Column>
                            <Grid.Column width={4} stretched textAlign="center">
                              <Input
                                fluid
                                name="item"
                                error={touched && !isEmpty(errors.item)}
                                placeholder="Netsuite product ID"
                                value={values.item}
                                onChange={(e, data) => setFieldValue("item", data.value)}
                                data-test="item"
                              />
                            </Grid.Column>
                          </Grid.Row>
                          <Grid.Row>
                            <Grid.Column verticalAlign="middle" width={4}>
                              <h4>Netsuite description</h4>
                            </Grid.Column>
                            <Grid.Column width={4} stretched textAlign="center">
                              <Input
                                fluid
                                name="netsuiteDescription"
                                error={touched && !isEmpty(errors.netsuiteDescription)}
                                placeholder="Netsuite product description"
                                value={values.netsuiteDescription}
                                onChange={(e, data) => setFieldValue("netsuiteDescription", data.value)}
                                data-test="netsuiteDescription"
                              />
                            </Grid.Column>
                          </Grid.Row>

                          {values.discountType === "percentage" && (
                            <Grid.Row>
                              <Grid.Column verticalAlign="middle" width={4}>
                                <h4>Amount</h4>
                              </Grid.Column>
                              <Grid.Column width={4} stretched textAlign="center">
                                <Input
                                  fluid
                                  name="amount"
                                  required
                                  error={touched && !isEmpty(errors.amount)}
                                  placeholder="Amount"
                                  value={values.amount}
                                  onChange={(e, data) => setFieldValue("amount", data.value)}
                                  type="number"
                                  data-test="amount"
                                />
                              </Grid.Column>
                            </Grid.Row>
                          )}

                          <Grid.Row columns={3} textAlign="left" verticalAlign="top">
                            <Grid.Column width={11}>
                              {values.discountType === "fixed" && (
                                <Grid.Row textAlign="left" verticalAlign="middle">
                                  <h5>Note! The price for the tenant default currency is mandatory!</h5>
                                </Grid.Row>
                              )}
                              <Grid>
                                {values.prices &&
                                  values.prices.map(
                                    (item, idx) =>
                                      !item.removed && (
                                        <Grid.Row columns={2} key={idx}>
                                          <Grid.Column verticalAlign="middle" width={4}>
                                            <h4>Amount</h4>
                                          </Grid.Column>
                                          <Grid.Column width={4} stretched textAlign="center">
                                            <Input
                                              id={item.id}
                                              name={`amount_${idx}`}
                                              value={item.amount}
                                              readOnly
                                              error={touched && !isEmpty(errors.amount)}
                                              placeholder="Amount"
                                              data-test="amount"
                                            />
                                          </Grid.Column>
                                          <Grid.Column width={4}>
                                            <Input
                                              id={item.id}
                                              name={`currency_${idx}`}
                                              value={item.currency}
                                              readOnly
                                              error={touched && !isEmpty(errors.amount)}
                                              data-test="currency"
                                            />
                                          </Grid.Column>
                                          <Grid.Column width={2} textAlign="right">
                                            {!values.addingCurrency && !values.editingCurrency && (
                                              <>
                                                <Icon
                                                  name="edit"
                                                  link
                                                  color="orange"
                                                  onClick={() => {
                                                    setFieldValue("editingCurrency", true);
                                                    setFieldValue("amountIndex", idx);
                                                    setFieldValue("amount", values.prices[idx].amount);
                                                    setFieldValue("currencyIndex", idx);
                                                    setFieldValue("currency", values.prices[idx].currency);
                                                  }}
                                                />
                                                <Icon
                                                  name="trash alternate"
                                                  link
                                                  color="orange"
                                                  onClick={() => {
                                                    setFieldValue("amount", 0);
                                                    if (values.prices[idx].currency !== this.props.currentTenantCurrency) {
                                                      values.prices[idx].removed = true;
                                                      setFieldValue("prices", values.prices);
                                                    }
                                                  }}
                                                />
                                              </>
                                            )}
                                          </Grid.Column>
                                        </Grid.Row>
                                      )
                                  )}
                              </Grid>
                              {values.addingCurrency && (
                                <Grid textAlign="left">
                                  <Grid.Row columns={2}>
                                    <Grid.Column width={4} stretched textAlign="center">
                                      <Input
                                        name="amount"
                                        placeholder="Insert Amount"
                                        defaultValue={0}
                                        fluid
                                        icon="pencil"
                                        type="number"
                                        iconPosition="left"
                                        error={touched && !isEmpty(errors.amount)}
                                        onChange={(e, data) => setFieldValue("amount", data.value)}
                                        value={values.amount}
                                        onBlur={handleBlur}
                                      />
                                      <ErrorMessage name="amount" component={Label} basic pointing color="red" />
                                    </Grid.Column>
                                    <Grid.Column width={3} stretched textAlign="center">
                                      <Dropdown
                                        name="currency"
                                        placeholder="Select Currency"
                                        value={values.currency}
                                        fluid
                                        selection
                                        options={
                                          tenantCurrencies !== null
                                            ? tenantCurrencies
                                                .map(item => {
                                                  return {
                                                    key: item.currency,
                                                    value: item.currency,
                                                    text: item.currency
                                                  };
                                                })
                                                .filter(
                                                  item => !values.prices.flatMap(item => item.currency).includes(item.value)
                                                )
                                            : []
                                        }
                                        onChange={(e, data) => {
                                          setFieldValue("currency", data.value);
                                        }}
                                      />
                                      <ErrorMessage name="item" component={Label} basic pointing color="red" />
                                    </Grid.Column>
                                    <Grid.Column width={4} textAlign="right">
                                      <Menu size="mini" borderless secondary floated="right">
                                        <Button
                                          size="mini"
                                          color="orange"
                                          content="OK"
                                          icon="add"
                                          type="button"
                                          onClick={() => {
                                            if (values.addingCurrency) {
                                              setFieldValue("prices", [
                                                ...values.prices,
                                                { amount: values.amount, currency: values.currency }
                                              ]);
                                              setFieldValue("addingCurrency", false);
                                            } else if (values.editingCurrency) {
                                              const { prices } = values;
                                              prices[values.amountIndex].amount = values.amount;
                                              prices[values.amountIndex].currency = values.currency;
                                              setFieldValue("prices", prices);
                                              setFieldValue("editingCurrency", false);
                                            }
                                            setFieldValue("amount", "0");
                                            setFieldValue("currency", "");
                                          }}
                                          disabled={!values.currency || values.amount < 0}
                                        />
                                        <Button
                                          size="mini"
                                          style={{
                                            backgroundColor: "#fff",
                                            color: "orange"
                                          }}
                                          content="Cancel"
                                          onClick={() => {
                                            setFieldValue("addingCurrency", false);
                                            setFieldValue("editingCurrency", false);
                                            setFieldValue("amount", "0");
                                            setFieldValue("currency", "");
                                          }}
                                        />
                                      </Menu>
                                    </Grid.Column>
                                  </Grid.Row>
                                </Grid>
                              )}
                              {values.editingCurrency && (
                                <Grid textAlign="left">
                                  <Grid.Row columns={2}>
                                    <Grid.Column width={4} stretched textAlign="center">
                                      <Input
                                        name="amount"
                                        placeholder="Insert Amount"
                                        defaultValue={0}
                                        fluid
                                        icon="pencil"
                                        type="number"
                                        iconPosition="left"
                                        error={touched && !isEmpty(errors.amount)}
                                        onChange={(e, data) => setFieldValue("amount", data.value)}
                                        value={values.amount}
                                        onBlur={handleBlur}
                                      />
                                      <ErrorMessage name="amount" component={Label} basic pointing color="red" />
                                    </Grid.Column>
                                    <Grid.Column width={3} stretched textAlign="center">
                                      <Input
                                        placeholder="Insert Currency"
                                        name="currency"
                                        value={values.currency}
                                        readOnly
                                        data-test="currency"
                                      />
                                      <ErrorMessage name="item" component={Label} basic pointing color="red" />
                                    </Grid.Column>
                                    <Grid.Column width={4} textAlign="right">
                                      <Menu size="mini" borderless secondary floated="right">
                                        <Button
                                          size="mini"
                                          color="orange"
                                          content="OK"
                                          icon="add"
                                          type="button"
                                          onClick={() => {
                                            if (values.addingCurrency) {
                                              setFieldValue("prices", [
                                                ...values.prices,
                                                { amount: values.amount, currency: values.currency }
                                              ]);
                                              setFieldValue("addingCurrency", false);
                                            } else if (values.editingCurrency) {
                                              const { prices } = values;
                                              prices[values.amountIndex].amount = values.amount;
                                              prices[values.amountIndex].currency = values.currency;
                                              setFieldValue("prices", prices);
                                              setFieldValue("editingCurrency", false);
                                            }
                                            setFieldValue("amount", "0");
                                            setFieldValue("currency", "");
                                          }}
                                          disabled={!values.amount || values.amount < 0}
                                        />
                                        <Button
                                          size="mini"
                                          style={{
                                            backgroundColor: "#fff",
                                            color: "orange"
                                          }}
                                          content="Cancel"
                                          onClick={() => {
                                            setFieldValue("addingCurrency", false);
                                            setFieldValue("editingCurrency", false);
                                            setFieldValue("amount", "0");
                                            setFieldValue("currency", "");
                                          }}
                                        />
                                      </Menu>
                                    </Grid.Column>
                                  </Grid.Row>
                                </Grid>
                              )}
                            </Grid.Column>
                          </Grid.Row>

                          {values.discountType === "fixed" && (
                            <Menu size="small" borderless secondary>
                              <Menu.Item
                                header
                                link
                                icon="add"
                                content="Add New Price"
                                className="text orange"
                                onClick={() => {
                                  setFieldValue("addingCurrency", true);
                                  setFieldValue("allowOutOfBundle", true);
                                }}
                                disabled={values.addingCurrency || values.editingCurrency}
                              />
                            </Menu>
                          )}

                          <Grid.Row>
                            <Grid.Column width={4}>
                              <h4>Discount type</h4>
                            </Grid.Column>
                            <Grid.Column width={4}>
                              <Dropdown
                                clearable
                                name="discountType"
                                placeholder="Select discount type"
                                fluid
                                onChange={(e, data) => {
                                  setFieldValue("discountType", data.value);
                                  if (data.value === "percentage") {
                                    setFieldValue("addingCurrency", false);
                                    setFieldValue("editingCurrency", false);
                                    setFieldValue("amount", 0);
                                    setFieldValue("prices", this.handlePrices(values.prices));
                                  } else if (data.value === "fixed") {
                                    setFieldValue("prices", [{ amount: 0, currency: this.props.currentTenantCurrency }]);
                                    setFieldValue("amount", 0);
                                  } else {
                                    setFieldValue("prices", this.handlePrices(values.prices));
                                    setFieldValue("addingCurrency", false);
                                    setFieldValue("editingCurrency", false);
                                  }
                                }}
                                value={values.discountType}
                                selection
                                options={[
                                  { key: "percentage", value: "percentage", text: "Percentage %" },
                                  { key: "fixed", value: "fixed", text: "Fixed" }
                                ]}
                                data-test="discountType"
                                error={touched && !isEmpty(errors.discountType)}
                              />
                            </Grid.Column>
                          </Grid.Row>
                          <Grid.Row>
                            <Grid.Column width={4}>
                              <h4>Applies on</h4>
                            </Grid.Column>
                            <Grid.Column width={2}>
                              <Radio
                                label="Product"
                                name="productRadioButton"
                                checked={values.discountableProductType === "Product"}
                                onChange={(e, data) => {
                                  setFieldValue("discountableProductSlug", "");
                                  setFieldValue("discountableProductType", "Product");
                                  appliesOnProduct();
                                }}
                              />
                              <br />
                              <Radio
                                label="Product group"
                                name="productGroupRadioButton"
                                checked={values.discountableProductType === "ProductGroup"}
                                onChange={(e, data) => {
                                  setFieldValue("discountableProductSlug", "");
                                  setFieldValue("discountableProductType", "ProductGroup");
                                  appliesOnProductGroup();
                                }}
                              />
                            </Grid.Column>
                            {values.discountableProductType === "Product" && (
                              <Grid.Column width={4}>
                                <Dropdown
                                  clearable
                                  name="product"
                                  placeholder="Select product"
                                  icon="search"
                                  search
                                  fluid
                                  onChange={(e, data) => this.handleProductChange(e, data, setFieldValue)}
                                  value={values.discountableProductSlug}
                                  selection
                                  options={
                                    !isEmpty(productOptions)
                                      ? productOptions.map((productOptions, index) => {
                                          return {
                                            key: productOptions.key,
                                            text: productOptions.text + " (" + productOptions.key + ") ",
                                            value: productOptions.value
                                          };
                                        })
                                      : []
                                  }
                                  data-test="product"
                                  error={touched && !isEmpty(errors.discountableProductSlug)}
                                  loading={isEmpty(productOptions)}
                                />
                              </Grid.Column>
                            )}
                            {values.discountableProductType === "ProductGroup" && (
                              <Grid.Column width={4}>
                                <Dropdown
                                  clearable
                                  name="productGroup"
                                  placeholder="Select product group"
                                  icon="search"
                                  search
                                  fluid
                                  onChange={(e, data) => this.handleProductChange(e, data, setFieldValue)}
                                  value={values.discountableProductSlug}
                                  selection
                                  options={productGroupOptions || []}
                                  data-test="productGroup"
                                  error={touched && !isEmpty(errors.discountableProductSlug)}
                                  loading={isEmpty(productGroupOptions)}
                                />
                              </Grid.Column>
                            )}
                          </Grid.Row>
                          <Grid.Row>
                            <Grid.Column width={4}>
                              <h4>Applies for</h4>
                            </Grid.Column>
                            <Grid.Column width={2}>
                              <Radio
                                label="Customer group"
                                name="customerGroupRadioButton"
                                checked={values.discountableCustomerType === "CustomerGroup"}
                                onChange={(e, data) => {
                                  setFieldValue("discountableCustomerSlug", "");
                                  setFieldValue("discountableCustomerType", "CustomerGroup");
                                  appliesForCustomerGroup();
                                }}
                              />
                            </Grid.Column>
                            {values.discountableCustomerType === "CustomerGroup" && (
                              <Grid.Column width={4}>
                                <Dropdown
                                  clearable
                                  name="customerGroup"
                                  placeholder="Select customer group"
                                  icon="search"
                                  search
                                  fluid
                                  onChange={(e, data) => {
                                    setFieldValue("discountableCustomerSlug", data.value);
                                  }}
                                  value={values.discountableCustomerSlug}
                                  selection
                                  options={
                                    customerGroupOptions || [{ key: tenantSlug, text: "All Customers", value: tenantSlug }]
                                  }
                                  data-test="customerGroup"
                                  error={touched && !isEmpty(errors.discountableCustomerSlug)}
                                  loading={isEmpty(customerGroupOptions)}
                                />
                              </Grid.Column>
                            )}
                          </Grid.Row>
                          <Grid.Row>
                            <Grid.Column>
                              <Button
                                data-test="updateDiscountGroupBtn"
                                color="orange"
                                disabled={!isValid || values.addingCurrency || values.editingCurrency}
                                type="submit"
                                content={page === "Create" ? page : "Update"}
                              />
                            </Grid.Column>
                          </Grid.Row>
                        </Grid>
                      </Form>
                    )}
                  </Formik>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Layout.Content>
        ) : (
          <Loader message="Loading customer group..." />
        )}
      </Layout.Page>
    );
  }
}

const mapStateToProps = state => ({
  customerInvoicesPrefix: get(state, "common.currentTenant.customerInvoicesPrefix"),
  currentTenantCurrency: get(state, "common.currentTenant.defaultCurrency"),
  tenantCurrencies: build(state.tenantCurrenciesReducer, "list", null, {
    ignoreLinks: true
  })
});

export default connect(mapStateToProps)(DiscountForm);
